"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Title_1 = __importDefault(require("antd/lib/typography/Title"));
const react_1 = __importStar(require("react"));
const ArrowLeftIcon_1 = __importDefault(require("mdi-react/ArrowLeftIcon"));
require("./Politics.scss");
const react_router_dom_1 = require("react-router-dom");
const HeaderMenuComponent_1 = __importDefault(require("../../components/headerMenuComponent/HeaderMenuComponent"));
const index_1 = __importDefault(require("../../components/underline/index"));
const HomeFooter_1 = __importDefault(require("../home/homeFooter/HomeFooter"));
const Cancel_1 = __importDefault(require("./Cancel"));
const PoliticsStyles_1 = require("./PoliticsStyles");
const Privacy_1 = __importDefault(require("./Privacy"));
const Terms_1 = __importDefault(require("./Terms"));
const helpers_1 = require("../../utils/helpers");
const Politics = ({ type }) => {
    const [content, setContent] = (0, react_1.useState)({});
    const [renderGoBack, setRenderGoBack] = (0, react_1.useState)('');
    const location = (0, react_router_dom_1.useLocation)();
    const renderContent = (0, react_1.useCallback)(() => {
        switch (type) {
            case 'privacy':
                setContent({
                    title: 'Política de Privacidade - 360 Suítes',
                    content: (0, Privacy_1.default)(),
                    page: '360 Suítes - Política de Privacidade',
                });
                break;
            case 'cancel':
                setContent({
                    title: 'Políticas de Cancelamento',
                    content: (0, Cancel_1.default)(),
                    page: '360 Suítes - Políticas de Cancelamento',
                });
                break;
            case 'terms':
                setContent({
                    title: 'Termos e Condições Gerais de Uso da plataforma da 360 Suítes',
                    content: (0, Terms_1.default)(),
                    page: '360 Suítes - Termos e Condições Gerais de Uso da plataforma da 360 Suítes',
                });
                break;
            default:
                setContent({
                    title: 'Política de Privacidade - 360 Suítes',
                    content: (0, Privacy_1.default)(),
                    page: '360 Suítes - Política de Privacidade',
                });
                break;
        }
    }, [type]);
    (0, react_1.useEffect)(() => {
        renderContent();
    }, [renderContent]);
    (0, react_1.useEffect)(() => {
        const isSafariReload = JSON.stringify(localStorage.getItem('XP360:isSafariReload'));
        if ((0, helpers_1.isBrowserSafari)() && isSafariReload === 'null') {
            localStorage.setItem('XP360:isSafariReload', JSON.stringify(true));
            window.location.reload();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        const state = location.state;
        if (state && state.from) {
            setRenderGoBack(state.from);
        }
        else {
            setRenderGoBack('/');
        }
    }, [location, renderGoBack]);
    (0, react_1.useEffect)(() => {
        if (content.page) {
            document.title = content.page;
        }
    }, [content.page]);
    return (react_1.default.createElement("div", { className: "Politics" },
        react_1.default.createElement(HeaderMenuComponent_1.default, null),
        react_1.default.createElement(PoliticsStyles_1.Content, null,
            renderGoBack && (react_1.default.createElement(react_router_dom_1.Link, { className: "btn-goback", to: renderGoBack },
                react_1.default.createElement(ArrowLeftIcon_1.default, null),
                react_1.default.createElement("span", null, "Voltar"))),
            react_1.default.createElement(Title_1.default, { level: 1 }, content.title),
            react_1.default.createElement(index_1.default, null),
            content.content),
        react_1.default.createElement(HomeFooter_1.default, null)));
};
exports.default = Politics;
